import {
  Crosshair1Icon,
  EyeOpenIcon,
  RocketIcon,
  UpdateIcon,
} from "@radix-ui/react-icons";
import KpiCard from "./KpiCard";
import {
  Card,
  CardContent,
} from "../../../../../../shared/components/card/Card";

const PrimaryKpis = ({ investment, impressions, conversions, revenue }) => {
  return (
    <Card className="w-2/3">
      <CardContent className="flex flex-row justify-between gap-x-2 p-4">
        <KpiCard
          label="Inversión"
          value={investment}
          icon={<Crosshair1Icon />}
          iconBgcolor="bg-adq-azure"
          bgColor="bg-adq-azure/50"
        />
        <KpiCard
          label="Impresiones"
          value={impressions}
          icon={<EyeOpenIcon />}
          iconBgcolor="bg-adq-yellow"
          bgColor="bg-adq-yellow/50"
        />
        <KpiCard
          label="Conversiones"
          value={conversions}
          icon={<UpdateIcon />}
          iconBgcolor="bg-adq-purple"
          bgColor="bg-adq-purple/50"
        />
        <KpiCard
          label="Revenue"
          value={revenue}
          icon={<RocketIcon />}
          iconBgcolor="bg-adq-aquamarine"
          bgColor="bg-adq-aquamarine/50"
        />
      </CardContent>
    </Card>
  );
};

export default PrimaryKpis;
